import { Helmet } from "react-helmet-async";
import { useQuery } from "@tanstack/react-query";
import {
  MarketingIntakeWizardContainer,
  intakeFormQuery,
} from "@platform/features/marketing";

export type Props = {
  /** Which configured form this address serves, as the configuration names it */
  formSlug: string;
};

/**
 * An address for an intake form.
 *
 * One component serves every audience, because the form itself is configured on
 * the server: the slug decides which fields are asked for, how many steps they
 * are asked over, whether a meeting is booked, and what the panel beside the
 * form says. Each form has an address of its own, named for the thing it does
 * rather than sitting under a shared one, so the router says which slug each
 * address serves and nothing is derived from the path.
 */
export default function ApplyPage({ formSlug }: Props) {
  // The same query the wizard runs, so naming the page costs no second request.
  const { data: config } = useQuery(intakeFormQuery(formSlug));

  return (
    <>
      <Helmet>
        <title>{["Pollinator", config?.name].filter(Boolean).join(" | ")}</title>
      </Helmet>
      <MarketingIntakeWizardContainer formSlug={formSlug} />
    </>
  );
}
